<template>
	<div>
		<!-- <div class="ml">
			<Button :type="type==1?'primary':''" class="" @click="xuanze(1)">商品运营</Button>
			<Button :type="type==2?'primary':''" @click="xuanze(2)">广告运营</Button>
			<Button :type="type==3?'primary':''" @click="xuanze(3)">设备运营</Button>
		</div> -->
		<router-view />
	</div>
</template>
<script>
	import http from '@/http/http.js'
	export default {
		
		data() {
			return {
				type:1,
			}
		},
		methods:{
			xuanze(type){
				let _this=this
				if(type!=_this.type){
					_this.type=type
					switch (type){
						case 1:
						    this.$router.push('/jmPlatformShangpingtongjiHome')
							break;
						case 2:
						    this.$router.push('/jmPlatformGuanggaotongjiHome')
							break;
						case 3:
						    this.$router.push('/jmPlatformShebeitongjiHome')
							break;
						default:
							break;
					}
				}
			}
		},
		created() {
			
		}
		
	}
</script>
<style>
	
	.mulu {
		display: flex;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/jm/platform/home.vue